<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt1')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <img class="bg" src="../../../assets/image/one/hunt_convert.png" alt="">
        <div class="text">
            <div>{{ $t('hunt2') }}</div>
            <div>{{ $t('hunt3') }}</div>
        </div>
        <div class="convert">
            <div class="convert_tle">{{ $t('hunt4') }}</div>
            <img class="convert_f" src="../../../assets/image/one/hunt_convert_f.png" alt="">
            <div class="convert_inp">
                <input type="text" disabled v-model="code" placeholder="">
            </div>
        </div>
    </div>
</template>
<script>
import { GetExchangeCode } from '../../../api/memberOne'
export default {
    name: 'HuntCash',
    data() {
        return {
            code: 'Dx980708',
        }
    },
    mounted(){
        const data = this.$route.query.data
        this.code = data
        this.activity_id = this.$route.query.activity_id
        if(this.activity_id) this.onGetExchangeCode()
    },
    methods: {
        onGetExchangeCode() {
            const activity_id = this.activity_id;
            GetExchangeCode({
                activity_id,
            }, 'one').then(res => {
                this.code = res.result.exchange_code
            })
        }
    }
}
</script>


<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;

    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .text{
        position: absolute;
        top: 25%;
        left: 50%;
        width: 70%;
        transform: translate(-50%, -50%);
        color: #CB1B19;
        font-size: 50px;
        font-weight: bold;
        div:nth-child(1){
            text-align: left;
        }
        div:nth-child(2){
            text-align: right;
        }
    }

    .convert {
        position: absolute;
        font-size: 27px;
        top: 60%;
        left: 50%;
        width: 70%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        color: #FFD4AA;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .convert_tle {
            font-size: 31px;
            color: #D41E16;
            font-weight: bold;
        }

        .convert_f {
            width: 80%;
            height: auto;
            padding: 10px 0 30px;
        }

        .convert_inp {
            width: 100%;

            input {
                width: 100%;
                // height: 57px;
                border-radius: 6px;
                border: none;
                outline: none;
                padding: 10px 0;
                box-sizing: border-box;
                margin: 0;
                background: #fff;
                color: #D41E16;
                font-size: 40px;
                box-shadow: none;
                appearance: none;
                -webkit-appearance: none;
                font-weight: 500;
                text-align: center;
            }
        }

        .convert_text {
            width: 100%;
            font-size: 15px;
            color: #D41E16;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 11px 0 15px;

            img {
                width: 14px;
                height: 14px;
                margin-right: 5px;
            }
        }
        .convert_btn{
            width: 80%;
            position: relative;
            font-weight: 800;
            font-size: 29px;
            color: #D41E16;
            line-height: 43px;
            height: 66px;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                z-index: 1;
                position: sticky;
                margin-top: -6px;
            }
            img{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 0;
            }
        }
    }
}
</style>
